import React, { useContext } from 'react';
import { Row, Col, Dropdown, Container, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import PropTypes from 'prop-types';
import './clearpoint.css';
import { AuthContext } from '../lib/contexts/AuthContext'

export function ContractLayout(props) {
    const { hasClaim } = useContext(AuthContext);
    const { contractNumber, queryString, contractStatus, isCombined, displayButtons, label } = props;
    const sectionLabel = label || (!isCombined ? ("Contract " + contractNumber) : "Combined Contract Details")
    const params = queryString || contractNumber

    return (
        <Container>
            <Row id={`cn${contractNumber}`}>
                <Col sm={4} className="section" style={{ paddingLeft: "15px", marginTop: "15px" }}>
                    <h2 style={{ marginBottom: 0 }}>{sectionLabel}</h2>
                </Col>
                {isCombined && displayButtons &&
                    <Col sm={8} className="text-end" style={{ marginTop: "15px" }}>
                        <ButtonGroup className="click-to-view" role="group" aria-label="...">
                            <span className="text-sm me-auto" style={{ padding: "10px", marginRight: "15px" }}>Click to view</span>
                            <LinkContainer className="ml-15" to={`/contracts-combined?n=${params}`}><button className="details-btn btn-default">Details</button></LinkContainer>
                            <LinkContainer to={`/contracts-disbursement-quote-request?n=${params}`}><button disabled={contractStatus !== 'Accepted'} className="quote-btn btn-default">Distribution Quote</button></LinkContainer>
                            <LinkContainer to={`/contract-payment-history?n=${params}&combined=true`}><button className="history-btn btn-default">Payment History</button></LinkContainer>
                        </ButtonGroup>
                    </Col>
                }
                {!isCombined &&
                    <Col sm={12} xl={8} className="text-right" style={{ marginTop: "15px" }}>
                        <ButtonGroup className="click-to-view" variant='secondary'>
                            <span className="text-sm pull-left" style={{ padding: "10px", marginRight: "15px" }}>Click to view</span>
                            <LinkContainer to={`/contracts/${contractNumber}`}><button className="details-btn btn-default">Details</button></LinkContainer>
                            <LinkContainer to={`/contracts/${contractNumber}/disbursement-quote-request`}><button disabled={contractStatus !== 'Accepted'} className="quote-btn btn-default">Distribution Quote</button></LinkContainer>
                            <DropdownButton className="reports-letters dropdown-button" id="bg-nested-dropdown" title="Reports/Letters" variant='' >
                                <LinkContainer to={`/contract-payment-history?n=${contractNumber}`}>
                                  <Dropdown.Item>Payment History</Dropdown.Item>
                                </LinkContainer>
                                <LinkContainer to={`/contracts/${contractNumber}/confirmation-receipt`}>
                                  <Dropdown.Item>Confirmation Receipt</Dropdown.Item>
                                </LinkContainer>
                                <LinkContainer to={`/contracts/${contractNumber}/purchaser-confirmation-receipt`}>
                                  <Dropdown.Item>Purchaser Confirmation Receipt</Dropdown.Item>
                                </LinkContainer>
                                <LinkContainer to={`/contracts/${contractNumber}/coup-letter`}>
                                  <Dropdown.Item>Contract Status Letter</Dropdown.Item>
                                </LinkContainer>
                                <LinkContainer to={`/contracts/${contractNumber}/ssi-letter`}>
                                  <Dropdown.Item>Social Security Benefits Letter</Dropdown.Item>
                                </LinkContainer>
                            </DropdownButton>
                            <LinkContainer to={`/document-upload/${contractNumber}`}><button className="upload-btn btn-default">Contract Update/Change</button></LinkContainer>
                            {hasClaim('ContractDocuments') && 
                                <LinkContainer to={`/contracts/${contractNumber}/documents`}><button className="contract-documents-btn btn-default">Contract Documents</button></LinkContainer>
                            }
                            </ButtonGroup>
                    </Col>
                }
            </Row >
            <Row>
                {props.children}
            </Row>
        </Container >
        );
}

ContractLayout.propTypes = {
    contractNumber: PropTypes.string.isRequired,
    queryString: PropTypes.string,
    contractStatus: PropTypes.string,
    isCombined: PropTypes.bool,
    displayButtons: PropTypes.bool,
    label: PropTypes.string
}
